// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { z } from 'zod';

export const investmentExperienceSchema = z.object({
  q_exp_gov_bonds: z.enum(['gov_bonds_2plus', 'gov_bonds_1', 'gov_bonds_none']),
  q_exp_listed_equity: z.enum([
    'listed_equity_2plus',
    'listed_equity_1',
    'listed_equity_none',
  ]),
  q_exp_mutual_funds: z.enum([
    'mutual_funds_2plus',
    'mutual_funds_1',
    'mutual_funds_none',
  ]),
  q_exp_etf_simple: z.enum(['etf_simple_2plus', 'etf_simple_1', 'etf_simple_none']),
  q_exp_unlisted_equity: z.enum([
    'unlisted_equity_2plus',
    'unlisted_equity_1',
    'unlisted_equity_none',
  ]),
  q_exp_structured_guaranteed: z.enum([
    'structured_guaranteed_2plus',
    'structured_guaranteed_1',
    'structured_guaranteed_none',
  ]),
  q_exp_structured_unguaranteed: z.enum([
    'structured_unguaranteed_2plus',
    'structured_unguaranteed_1',
    'structured_unguaranteed_none',
  ]),
  q_exp_complex_bonds: z.enum([
    'complex_bonds_2plus',
    'complex_bonds_1',
    'complex_bonds_none',
  ]),
  q_exp_hybrid_products: z.enum([
    'hybrid_products_2plus',
    'hybrid_products_1',
    'hybrid_products_none',
  ]),
  q_exp_alternative_invest: z.enum([
    'alternative_invest_2plus',
    'alternative_invest_1',
    'alternative_invest_none',
  ]),
  q_exp_exchange_derivatives: z.enum([
    'exchange_derivatives_2plus',
    'exchange_derivatives_1',
    'exchange_derivatives_none',
  ]),
  q_exp_otc_derivatives: z.enum([
    'otc_derivatives_2plus',
    'otc_derivatives_1',
    'otc_derivatives_none',
  ]),
});

export type InvestmentExperienceFormData = z.infer<
  typeof investmentExperienceSchema
>;
